<template>
  <i class="mdi mdi-arrow-right-thick" :style="style"></i>
</template>

<script>
export default {
  props: {
    style: { type: String },
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.mdi {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.2);
}
</style>
